import React, { useId } from 'react';
import { calculateNEISBytes } from '../../utils/neisBytes';
import './SaenggibuContentEditor.css';

const SaenggibuContentEditor = ({
  ariaLabel = '생기부 내용 수정',
  autoFocus = true,
  className = '',
  isSaving = false,
  maxBytes,
  onCancel,
  onChange,
  onSave,
  rows = 8,
  showByteCount = true,
  targetBytes,
  value = '',
  variant = 'default',
}) => {
  const inputId = useId();
  const currentBytes = calculateNEISBytes(value);
  const normalizedMaxBytes = Number(maxBytes) > 0 ? Number(maxBytes) : null;
  const normalizedTargetBytes = Number(targetBytes) > 0 ? Number(targetBytes) : null;
  const isOverLimit = normalizedMaxBytes !== null && currentBytes > normalizedMaxBytes;
  const classes = [
    'saenggibu-content-editor',
    `saenggibu-content-editor--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} onClick={(event) => event.stopPropagation()}>
      <label className="saenggibu-content-editor__sr-only" htmlFor={inputId}>
        {ariaLabel}
      </label>
      <textarea
        id={inputId}
        aria-label={ariaLabel}
        autoFocus={autoFocus}
        className="saenggibu-content-editor__textarea"
        disabled={isSaving}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          event.stopPropagation();
          if (event.key === 'Escape' && !isSaving) {
            onCancel();
          }
        }}
        rows={rows}
        value={value}
      />
      <div className="saenggibu-content-editor__footer">
        {showByteCount && (
          <div className="saenggibu-content-editor__counts" aria-live="polite">
            <strong className={isOverLimit ? 'saenggibu-content-editor__count--over' : ''}>
              {currentBytes}B
            </strong>
            {normalizedTargetBytes !== null && <span>목표 {normalizedTargetBytes}B</span>}
            {isOverLimit && (
              <span className="saenggibu-content-editor__warning">
                최대 {normalizedMaxBytes}B를 넘었어요
              </span>
            )}
          </div>
        )}
        <div className="saenggibu-content-editor__actions">
          <button
            type="button"
            className="saenggibu-content-editor__cancel"
            disabled={isSaving}
            onClick={onCancel}
          >
            취소
          </button>
          <button
            type="button"
            className="saenggibu-content-editor__save"
            disabled={isSaving || !value.trim()}
            onClick={onSave}
          >
            {isSaving ? '저장 중...' : '저장하기'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaenggibuContentEditor;
